import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _typeof from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import KvBlock from '@/components/kiva/kv-editor/KvBlock';
import KivaProxy from '@/utils/kivaProxy/src';
var moment = require("moment");
var _require = require('js-base64'),
  Base64 = _require.Base64;
/* 
    List methods 

    get_field_data
    
    delete_task
    upsert_task
    get_tasks

    get_project_section
    get_accounts
    get_projects

    get_subtasks
    delete_subtask
    save_subtasks

    get_notes
    save_note

    save_dependency
    list_task_dependency
    delete_dependency

    get_time_entry
    save_time_entry

    get_attachments
    delete_attachment
    upload_attachments

*/
var Main = {
  title: "",
  fields: {},
  get_field_data: function () {
    var _get_field_data = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(props) {
      var modelId, appId, fieldId, res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // let jsearch = JSON.stringify({field_id:["=",props.field_id]})
            modelId = props.modelId;
            appId = props.appId;
            fieldId = props.fieldId;
            res = new KivaProxy({
              endpoint: appId + "/" + modelId + "/" + fieldId + "/options"
            }).all().then( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return data.records;
                    case 2:
                      _context.t0 = _context.sent;
                      return _context.abrupt("return", {
                        status: "Success",
                        records: _context.t0
                      });
                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x2) {
                return _ref.apply(this, arguments);
              };
            }()).catch(function (err) {
              return {
                status: "Fail",
                records: []
              };
            });
            return _context2.abrupt("return", res);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function get_field_data(_x) {
      return _get_field_data.apply(this, arguments);
    }
    return get_field_data;
  }(),
  delete_task: function () {
    var _delete_task = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(task, isRefresh) {
      var record_id, _res;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            record_id = task.record_id;
            if (!(record_id && record_id != null)) {
              _context3.next = 6;
              break;
            }
            // console.log(record_id)
            _res = new KivaProxy({
              endpoint: "act/task"
            }).destroy(record_id).then(function (data) {
              if (data.success == true) {
                return returnSuccess(data, "DELETE");
              } else {
                return returnError(data.err, "DELETE");
              }
            }).catch(function (err) {
              return returnError(err, "DELETE");
            });
            return _context3.abrupt("return", _res);
          case 6:
            return _context3.abrupt("return", {
              status: "Fail",
              records: [],
              text: "Gerekli değer gelmedi",
              err: "err"
            });
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function delete_task(_x3, _x4) {
      return _delete_task.apply(this, arguments);
    }
    return delete_task;
  }(),
  upsert_task: function () {
    var _upsert_task = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(params) {
      var parse_responsibles, arr, sending_params, params_arr, records, _records;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            // Task kaydedilme işlemi 
            if (params && params.project_name && typeof params.project_name != "undefined") {
              params.project = params.project_name;
              delete params.project_name;
            } else if (params && params.project && _typeof(params.project) == "object" && typeof params.project.value != "undefined" && params.project.value != "") {
              params.project = params.project.value;
            } else if (params && params.project) {
              params.project = params.project;
            }
            if ((!params.from || params.from == "inside") && params && params.users && params.users[0]) {
              parse_responsibles = get_responsibles_in_arr(params.users);
              params.record_owner = parse_responsibles.record_owner ? parse_responsibles.record_owner : params.record_owner ? params.record_owner : '';
              params.followers = parse_responsibles.followers ? parse_responsibles.followers : params.followers ? params.followers : '';
              delete params.users;
            } else if (params.from && params.from == "standart") {
              params.record_owner = params.record_owner && params.record_owner.value ? params.record_owner.value : params.record_owner ? params.record_owner : '';
              if (params.followers_array) {
                arr = params.followers_array.map(function (k) {
                  return k.recordId ? 'U' + k.recordId : 'U' + k;
                });
                params.followers = arr && arr[0] ? arr.join(",") : '';
              }
            } else {
              params.record_owner = params.record_owner && params.record_owner.value ? params.record_owner.value : params.record_owner ? params.record_owner : '';
              params.followers = typeof params.followers == "string" ? params.followers : params.followers && params.followers[0] ? params.followers.join(",") : '';
            }
            if (params && params.task_status && params.task_status.value) {
              params.task_status = params.task_status.value;
              params.status = params.task_status.value;
            } else if (params && params.task_status && params.task_status) {
              params.task_status = parseInt(params.task_status);
              params.status = params.task_status.value;
            } else {
              if (params && params.status && params.status.value) {
                params.task_status = params.status.value;
              } else if (params && params.status && params.status) {
                params.task_status = parseInt(params.status);
              }
            }
            if (params && params.section && params.section.value != "") {
              params.section = params.section.value;
            }
            if (params && params.task_type && params.task_type.value != "") {
              params.task_type = params.task_type.value;
            }
            if (params && params.account_name && params.account_name.value != "") {
              params.account_name = params.account_name.value;
            }
            if (params && params.priority && params.priority.value != "") {
              params.priority = params.priority.value;
            } else if (params && params.priority) {
              params.priority = params.priority.value;
            }
            if (params && params.dependency && params.dependency.value && params.dependency.value != "") {
              params.dependency = params.dependency.value;
            }
            if (params && params.thread && params.thread.value && params.thread.value != "") {
              params.thread = params.thread.value;
            }
            if (params && params.expected_duration) {
              params.expected_duration = Math.round(params.expected_duration / 60 * 100) / 100;
            }
            if (params && params.hold_reason) {
              params.hold_reason = params.hold_reason;
            }
            if (params && params.end_date_dmy && params.end_date_dmy != "" && params.end_date_dmy != "Invalid date") {
              params.end_date = moment(params.end_date_dmy + " 23:59:59").format("YYYY-MM-DD HH:mm:ss");
              if (params && params.start_date_dmy && params.start_date_dmy != "" && params.start_date_dmy != "Invalid date") {
                params.start_date = moment(params.start_date_dmy + " 23:59:59").format("YYYY-MM-DD HH:mm:ss");
              } else {
                params.start_date = moment(params.end_date_dmy + " 00:00:00").format("YYYY-MM-DD HH:mm:ss");
                params.allday = 1;
              }
            }

            // console.log("params",params)
            sending_params = {};
            params_arr = ["status", "visible_on_cp", "thread", "priority", "record_id", "task_status", "start_date", "end_date", "allday", "project", "record_owner", "followers", "description", "task_results", "subject", "expected_duration", "status", "section", "dependency", "task_type", "account_name", "hold_reason", "rescheduling_reason", "due_date_scheduled_on"];
            if (params) {
              params_arr.forEach(function (element) {
                if (typeof params[element] != "undefined") {
                  sending_params[element] = params[element];
                }
              });
            }
            if (!(sending_params.record_id && sending_params.record_id != null && sending_params.record_id != "0" && sending_params.record_id != "new")) {
              _context4.next = 22;
              break;
            }
            records = [_objectSpread({}, sending_params)];
            _context4.next = 19;
            return new KivaProxy({
              endpoint: 'act/task'
            }).update(records).then(function (data) {
              Main.saveLabels(params.record_id, params.selectedLabels);
              if (data.success == true) {
                return returnSuccess(data, "UPDATE");
              } else {
                return returnError(data.err, "UPDATE");
              }
            }).catch(function (err) {
              return returnError(err, "UPDATE");
            });
          case 19:
            return _context4.abrupt("return", _context4.sent);
          case 22:
            // sending_params.record_owner =  sending_params.users && sending_params.users[0] ? sending_params.users[0] : ''    
            if (sending_params.record_id) {
              delete sending_params.record_id;
            }
            _records = [_objectSpread({}, sending_params)];
            _context4.next = 26;
            return new KivaProxy({
              endpoint: 'act/task'
            }).create(_records).then(function (data) {
              if (data.success == true) {
                return returnSuccess(data, "CREATE");
              } else {
                return returnError(data.err, "CREATE");
              }
            }).catch(function (err) {
              return returnError(err, "CREATE");
            });
          case 26:
            return _context4.abrupt("return", _context4.sent);
          case 27:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function upsert_task(_x5) {
      return _upsert_task.apply(this, arguments);
    }
    return upsert_task;
  }(),
  get_task: function () {
    var _get_task = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(record_id) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", new KivaProxy({
              endpoint: "act/task"
            }).setFields(["hold_reason", "rescheduling_reason", "due_date_scheduled_on", "status", "thread", "priority", "account_name", "visible_on_cp", "customer_comments_done", "customer_comments_count", "task_type", "spent_time", "created_on", "created_by", "last_modified_on", "last_modified_by", "overdue_duration", "support_assignees", "dependency_count", "subject", "expected_duration", "dependency", "allday", "photo", "task_results", "description", "followers", "sub_tasks", "section", "sub_tasks", "start_date", "end_date", "record_owner", "project", "task_status", "project/project_status", "project/record_owner"]).setParameter("checkNotes", 1).setParameter("checkAtc", 1).find(record_id).then(function (response) {
              var _require2 = require('@/transformers/ActTaskTransformer'),
                ActTaskTransformer = _require2.ActTaskTransformer;
              var record = ActTaskTransformer.fetch(response.record);
              return record;
            }));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function get_task(_x6) {
      return _get_task.apply(this, arguments);
    }
    return get_task;
  }(),
  get_tasks: function () {
    var _get_tasks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(params) {
      var search, limit, start, orderSort, orderDir, search_with_group, searchKeyword, gviewId, jsearch;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            search = {};
            if (params.account_name) {
              search.account_name = ["=", params.account_name];
            }
            if (params.account_name_custom) {
              search.account_name_custom = ["CUSTOM", "cfd_project.account_name = '" + params.account_name_custom + "'"];
            }
            // search.task_status_custom = ["CUSTOM", "cfd_task_status.value = 'CLOSED'"]  
            if (params.act_task_id) {
              search.act_task_id = ["=", params.act_task_id];
            }
            if (params.project_name) {
              search.project = ["=", params.project_name];
            } else if (params.project) {
              search.project = ["=", params.project];
            }
            limit = 1000;
            start = 0;
            if (params.limit) {
              limit = params.limit;
              start = params.page * limit - limit;
            }
            orderSort = 'end_date';
            orderDir = 'DESC';
            if (params.dir && params.dir == "ASC") {
              orderDir = params.dir;
            }
            if (params.sort) {
              orderSort = params.sort;
            }
            if (params.getAllTasks == true || params.relation == "all") {} else if (params.user_id) {
              search.record_owner = ["=", params.user_id];
            } else if (params.searched_user && params.searched_user[0]) {
              // search.record_owner = ["=", params.searched_user];
              search_with_group = [];
              params.searched_user.forEach(function (element) {
                search_with_group.push({
                  record_owner: [{
                    record_owner: ["=", element]
                  }, {
                    created_by: ["=", element]
                  }, {
                    followers: ["CONTAINS ANY", 'U' + element]
                  }, {
                    "dependency": ["CUSTOM", "child_act_task_dependency__task.record_owner = ".concat(element, " AND child_act_task_dependency__task.done = 0")]
                  }]
                });
              });
              search.record_owner = [].concat(search_with_group);
            } else if (params.me && (!params.list_type || params.list_type && params.list_type.charAt(0) == 'u')) {
              search.record_owner = [{
                record_owner: ["=", params.me]
              }, {
                created_by: ["=", params.me]
              }, {
                followers: ["CONTAINS ANY", 'U' + params.me]
              }, {
                "dependency": ["CUSTOM", "child_act_task_dependency__task.record_owner = ".concat(params.me, " AND child_act_task_dependency__task.done = 0")]
              }

              // {support_assignees: ["=", params.me]}
              ];
            }

            if (params.record_id) {
              search.record_id = ["=", params.record_id];
            }
            if (params.record_owner) {
              search.record_owner = ["=", params.record_owner];
            }
            if (params.task_status && params.task_status == "open") {
              // search.task_status_custom = ["CUSTOM", "cfd_task_status.value != 'CLOSED'"]  
              search.task_status_custom = [{
                "task_status_custom1": ["CUSTOM", "cfd_task_status.value != 'CLOSED'"]
              }];
            } else if (params.task_status && params.task_status == "active") {
              // search.task_status_custom = ["CUSTOM", "cfd_task_status.value != 'CLOSED'"]  
              search.task_status_custom = [{
                "task_status_custom1": ["CUSTOM", "cfd_task_status.value = 'PROGRESS'"]
              }, {
                "task_status_custom1": ["CUSTOM", "cfd_task_status.value = 'OPEN'"]
              }];
            } else if (params.task_status && params.task_status == "progress") {
              // search.task_status_custom = ["CUSTOM", "cfd_task_status.value != 'CLOSED'"]  
              search.task_status_custom = [{
                "task_status_custom1": ["CUSTOM", "cfd_task_status.value = 'PROGRESS'"]
              }];
            } else if (params.task_status && params.task_status == "closed") {
              search.task_status_custom = ["CUSTOM", "cfd_task_status.value = 'CLOSED'"];
            }
            searchKeyword = '';
            if (params.subject) {
              searchKeyword = params.subject;
            }
            if (!params.search) {
              params.search = {};
            }
            if (params.search.anyText) {
              searchKeyword = params.search.anyText;
            }
            gviewId = "all";
            if (params.gviewId == "my_open_tasks") {
              gviewId = "all";
            } else if (params.gviewId) {
              gviewId = params.gviewId;
            } else if (params.search && params.search.task_status && params.search.task_status == "closed") {
              gviewId = "all_completed_tasks";
            }
            jsearch = JSON.stringify(search);
            _context6.next = 25;
            return new KivaProxy({
              endpoint: 'act/task'
            }).setFields(["hold_reason", "rescheduling_reason", "due_date_scheduled_on", "task_type", "thread", "priority", "visible_on_cp", "customer_comments_count", "customer_comments_done", "account_name", "spent_time", "created_on", "created_by", "last_modified_on", "last_modified_by", "overdue_duration", "support_assignees", "dependency_count", "subject", "expected_duration", "dependency", "allday", "photo", "task_results", "description", "followers", "sub_tasks", "section", "section/content", "sub_tasks", "start_date", "end_date", "record_owner", "project", "task_status", "project/project_status", "project/record_owner"]).setViewId(gviewId).setFilters(jsearch).setKeyword(searchKeyword).setStart(start).setLimit(limit).setSort(orderSort).setDir(orderDir).setParameter("checkNotes", 1).setParameter("checkAtc", 1).all().then(function (data) {
              var _require3 = require('@/transformers/ActTaskTransformer'),
                ActTaskTransformer = _require3.ActTaskTransformer;
              var records = ActTaskTransformer.fetchCollection(data.records);
              return {
                status: "Success",
                records: records,
                total: data.total
              };
            }).catch(function (err) {
              return {
                status: "Fail",
                records: []
              };
            });
          case 25:
            return _context6.abrupt("return", _context6.sent);
          case 26:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    function get_tasks(_x7) {
      return _get_tasks.apply(this, arguments);
    }
    return get_tasks;
  }(),
  saveLabels: function saveLabels(taskId, labels) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var labelId, all_labels_Id, search, jsearch;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            labelId = null;
            all_labels_Id = [];
            if (labels && labels[0]) {
              labels.forEach(function (k, i) {
                if (k) {
                  // önce yeni olanların kaydı
                  if (typeof k == "string") {
                    new KivaProxy({
                      endpoint: 'act/task_label'
                    }).create([{
                      label_name: k
                    }]).then(function (data) {
                      labelId = data.record.record_id;
                      all_labels_Id.push(labelId);
                    }).catch(function (err) {});
                  } else if (typeof k == "number") {
                    labelId = k;
                    all_labels_Id.push(labelId);
                  }

                  // 2.aşama da yeni atananların kontrolü ve  kaydı
                  var search2 = {
                    task: ["=", taskId],
                    label: ["=", labelId]
                  };
                  var jsearch2 = JSON.stringify(search2);
                  new KivaProxy({
                    endpoint: 'act/task_labels'
                  }).setFilters(jsearch2).all().then(function (response) {
                    // eğer yeni atanmışsa kaydediliyot.
                    if (!response.records[0]) {
                      new KivaProxy({
                        endpoint: 'act/task_labels'
                      }).create([{
                        label: labelId,
                        task: taskId
                      }]).then(function (data) {}).catch(function (err) {});
                    }
                  });
                }
              });
            }
            // Son aşamada daha önce var olup şimdi olmayanlar siliniyor.
            search = {
              task: ["=", taskId]
            };
            jsearch = JSON.stringify(search);
            new KivaProxy({
              endpoint: 'act/task_labels'
            }).setFilters(jsearch).all().then(function (response) {
              var all = response.records;
              all.forEach(function (k) {
                if (all_labels_Id && all_labels_Id.includes(k.label.value)) {} else {
                  new KivaProxy({
                    endpoint: 'act/task_labels'
                  }).destroy(k.record_id);
                }
              });
            });
          case 6:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  },
  get_project_section: function () {
    var _get_project_section = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(params) {
      var search;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            search = {};
            if (params.project) {
              search.project = ["=", params.project];
              // search.aktif_sozlesme="1";
            }

            search.section_status = ["!=", 3];
            _context8.next = 5;
            return new KivaProxy({
              endpoint: 'act/section'
            }).setFilters(search).setSort('section_name').setDir('ASC').setLimit(1000).all().then(function (data) {
              // console.log(data)
              return {
                status: "Success",
                records: data.records
              };
            }).catch(function (err) {
              return {
                status: "Fail",
                records: []
              };
            });
          case 5:
            return _context8.abrupt("return", _context8.sent);
          case 6:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    function get_project_section(_x8) {
      return _get_project_section.apply(this, arguments);
    }
    return get_project_section;
  }(),
  get_accounts: function () {
    var _get_accounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(active) {
      var search;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            search = {};
            if (active.rating == 2 || active.rating == 4 || active.rating == 1891 || active.rating == 1892 || active.rating == 1918) {
              search.rating = ["=", active.rating];
              // search.aktif_sozlesme="1";
            }
            _context9.next = 4;
            return new KivaProxy({
              endpoint: 'crm/account'
            }).setFilters(search).setLimit(1000).all().then(function (data) {
              // console.log(data)
              return {
                status: "Success",
                records: data.records
              };
            }).catch(function (err) {
              return {
                status: "Fail",
                records: []
              };
            });
          case 4:
            return _context9.abrupt("return", _context9.sent);
          case 5:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    function get_accounts(_x9) {
      return _get_accounts.apply(this, arguments);
    }
    return get_accounts;
  }(),
  get_projects: function () {
    var _get_projects = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(active) {
      var storeName, storage, max, dataStored, oldData, diff, search;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            storeName = 'act_project';
            storage = window.localStorage.getItem(storeName);
            max = 15;
            dataStored = false;
            if (!(active.force != true && storage && storage.charAt(0) == '{')) {
              _context10.next = 11;
              break;
            }
            oldData = JSON.parse(storage);
            diff = (new Date().getTime() - oldData.time) / 1000;
            if (!(diff < max && diff > 0)) {
              _context10.next = 11;
              break;
            }
            dataStored = true;
            console.log(" 531  ", oldData.options);
            return _context10.abrupt("return", {
              status: "Success",
              records: JSON.parse(Base64.decode(oldData.options))
            });
          case 11:
            if (!(dataStored == false)) {
              _context10.next = 17;
              break;
            }
            search = {};
            search.archived = ["=", "0"];
            _context10.next = 16;
            return new KivaProxy({
              endpoint: 'act/project'
            }).setFields(["account_name", "time_estimation_required", "time_entry_required", "completed_tasks_rate", "created_on", "dependent_task_assignees", "dependent_task_duration", "dependent_tasks", "due_date", "follow_up_on", "last_update_date", "last_update_message", "open_task_assignees", "open_task_duration", "open_tasks", "overdue_task_assignees", "overdue_task_duration", "overdue_tasks", "project_group", "project_name", "project_status", "raw_dependent_task_duration", "record_id", "record_owner", "relatedData", "start_date", "team"]).setLimit(1200).all().then(function (response) {
              var spData = {
                time: new Date().getTime(),
                options: Base64.encode(JSON.stringify(response.records))
              };
              window.localStorage.setItem(storeName, JSON.stringify(spData));
              return {
                status: "Success",
                records: response.records
              };
            }).catch(function (err) {
              return {
                status: "Fail",
                records: [],
                err: err
              };
            });
          case 16:
            return _context10.abrupt("return", _context10.sent);
          case 17:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    function get_projects(_x10) {
      return _get_projects.apply(this, arguments);
    }
    return get_projects;
  }(),
  get_project_groups: function () {
    var _get_project_groups = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(active) {
      var search;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            search = {};
            search.archived = ["=", "0"];
            _context11.next = 4;
            return new KivaProxy({
              endpoint: 'act/project_group'
            }).all().then(function (response) {
              return {
                status: "Success",
                records: response.records
              };
            }).catch(function (err) {
              return {
                status: "Fail",
                records: []
              };
            });
          case 4:
            return _context11.abrupt("return", _context11.sent);
          case 5:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    function get_project_groups(_x11) {
      return _get_project_groups.apply(this, arguments);
    }
    return get_project_groups;
  }(),
  get_project_updates: function () {
    var _get_project_updates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(id) {
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return new KivaProxy({
              endpoint: 'act/update'
            }).setFilters({
              "project": ["=", id]
            }).all().then(function (response) {
              return {
                status: "Success",
                records: response.records
              };
            }).catch(function (err) {
              return {
                status: "Fail",
                records: []
              };
            });
          case 2:
            return _context12.abrupt("return", _context12.sent);
          case 3:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    function get_project_updates(_x12) {
      return _get_project_updates.apply(this, arguments);
    }
    return get_project_updates;
  }(),
  get_subtasks: function () {
    var _get_subtasks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(params) {
      var search;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            search = {};
            if (params.main_task) {
              search.main_task = ["=", params.main_task];
            }
            _context13.next = 4;
            return new KivaProxy({
              endpoint: 'act/subtask'
            }).setFilters(search).setFields(["sort_order", "done", "main_task", "subject", "record_owner", "created_on", "created_by"]).setSort("sort_order").setDir('ASC').setLimit(1000).all().then(function (data) {
              return {
                status: "Success",
                records: data.records
              };
            }).catch(function (err) {
              return {
                status: "Fail",
                records: []
              };
            });
          case 4:
            return _context13.abrupt("return", _context13.sent);
          case 5:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    function get_subtasks(_x13) {
      return _get_subtasks.apply(this, arguments);
    }
    return get_subtasks;
  }(),
  delete_subtask: function () {
    var _delete_subtask = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(subtask) {
      var record_id, response;
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            record_id = subtask.record_id;
            if (!(record_id && record_id != null)) {
              _context14.next = 6;
              break;
            }
            // console.log(record_id)
            response = new KivaProxy({
              endpoint: "act/subtask"
            }).destroy(record_id).then(function (data) {
              if (data.success == true) {
                return returnSuccess(data, "DELETE");
              } else {
                return returnError(data.err, "DELETE");
              }
            }).catch(function (err) {
              return returnError(err, "DELETE");
            });
            return _context14.abrupt("return", response);
          case 6:
            return _context14.abrupt("return", {
              status: "Fail",
              records: [],
              text: "Gerekli değer gelmedi",
              err: "err"
            });
          case 7:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }));
    function delete_subtask(_x14) {
      return _delete_subtask.apply(this, arguments);
    }
    return delete_subtask;
  }(),
  save_subtasks: function () {
    var _save_subtasks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(subtasks) {
      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(resolve, reject) {
                var all_subtasks, total, records, patch, post, post_return, patch_return, a, b, arr;
                return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                  while (1) switch (_context15.prev = _context15.next) {
                    case 0:
                      if (!subtasks) {
                        _context15.next = 29;
                        break;
                      }
                      all_subtasks = Object.keys(subtasks);
                      total = all_subtasks.length - 1;
                      records = [];
                      patch = [];
                      post = [];
                      all_subtasks.forEach(function (p, i) {
                        if (subtasks[p]) {
                          var params = subtasks[p];
                          if (params.subject != "") {
                            if (params && params.record_owner && params.record_owner.value) {
                              params.record_owner = params.record_owner.value;
                            }
                            if (params && params.main_task && params.main_task.value) {
                              params.main_task = params.main_task.value;
                            }
                            params.sort_order = i;
                            if (params.record_id && params.record_id != null && params.record_id != "0" && params.record_id != "new") {
                              patch.push(_objectSpread({}, params));
                            } else {
                              post.push(_objectSpread({}, params));
                            }
                            records.push(_objectSpread({}, params));
                          }
                        }
                      });
                      post_return = {};
                      patch_return = {};
                      a = 1;
                      b = 1;
                      if (!patch[0]) {
                        _context15.next = 22;
                        break;
                      }
                      // let arr = patch.length>3 ? Main.chunk_inefficient(4,patch) : [patch];
                      arr = patch.length > 49 ? Main.chunk_inefficient(50, patch) : [patch];
                      _context15.next = 15;
                      return new KivaProxy({
                        endpoint: 'act/subtask'
                      }).update(arr[0]).then(function (data) {
                        if (data.success == true) {
                          return returnSuccess(data, "UPDATE");
                        } else {
                          return returnError(data.err, "UPDATE");
                        }
                      }).catch(function (err) {
                        return returnError(err, "UPDATE");
                      });
                    case 15:
                      patch_return = _context15.sent;
                      if (!arr[1]) {
                        _context15.next = 19;
                        break;
                      }
                      _context15.next = 19;
                      return new KivaProxy({
                        endpoint: 'act/subtask'
                      }).update(arr[1]).then(function (data) {
                        if (data.success == true) {
                          return returnSuccess(data, "UPDATE");
                        } else {
                          return returnError(data.err, "UPDATE");
                        }
                      }).catch(function (err) {
                        return returnError(err, "UPDATE");
                      });
                    case 19:
                      if (!arr[2]) {
                        _context15.next = 22;
                        break;
                      }
                      _context15.next = 22;
                      return new KivaProxy({
                        endpoint: 'act/subtask'
                      }).update(arr[2]).then(function (data) {
                        if (data.success == true) {
                          return returnSuccess(data, "UPDATE");
                        } else {
                          return returnError(data.err, "UPDATE");
                        }
                      }).catch(function (err) {
                        return returnError(err, "UPDATE");
                      });
                    case 22:
                      if (!post[0]) {
                        _context15.next = 26;
                        break;
                      }
                      _context15.next = 25;
                      return new KivaProxy({
                        endpoint: 'act/subtask'
                      }).create(post).then(function (data) {
                        if (data.success == true) {
                          return returnSuccess(data, "CREATE");
                        } else {
                          return returnError(data.err, "CREATE");
                        }
                      }).catch(function (err) {
                        return returnError(err, "CREATE");
                      });
                    case 25:
                      post_return = _context15.sent;
                    case 26:
                      if (total && post_return && post_return.status != "Fail" && patch_return.status != "Fail") {
                        if (post_return.status) {
                          resolve(post_return);
                        }
                        if (patch_return.status) {
                          resolve(patch_return);
                        }
                      }
                      _context15.next = 30;
                      break;
                    case 29:
                      resolve({
                        status: "Fail",
                        records: [],
                        text: "Veri Bulunamadı",
                        err: "Veri yok!!"
                      });
                    case 30:
                    case "end":
                      return _context15.stop();
                  }
                }, _callee15);
              }));
              return function (_x16, _x17) {
                return _ref2.apply(this, arguments);
              };
            }()));
          case 1:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    }));
    function save_subtasks(_x15) {
      return _save_subtasks.apply(this, arguments);
    }
    return save_subtasks;
  }(),
  chunk_inefficient: function chunk_inefficient(chunkSize, array) {
    return [].concat.apply([], array.map(function (elem, i) {
      return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
    }));
  },
  get_notes: function () {
    var _get_notes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(recordId) {
      return _regeneratorRuntime().wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return new KivaProxy({
              endpoint: "act/task/" + recordId + "/note"
            }).setLimit(1000).all().then(function (data) {
              return {
                status: "Success",
                records: data.data
              };
            }).catch(function (err) {
              return {
                status: "Fail",
                records: []
              };
            });
          case 2:
            return _context17.abrupt("return", _context17.sent);
          case 3:
          case "end":
            return _context17.stop();
        }
      }, _callee17);
    }));
    function get_notes(_x18) {
      return _get_notes.apply(this, arguments);
    }
    return get_notes;
  }(),
  save_note: function () {
    var _save_note = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(note) {
      var record_id;
      return _regeneratorRuntime().wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            // let search = {}
            // if (params.main_task) {
            //     search.main_task = ["=", params.main_task]; 
            // }
            record_id = note.record_id;
            delete note.record_id;
            // console.log("/data/act/task/"+record_id+"/note")
            // console.log(note)
            if (!(!note.note_id || note.note_id == "" || note.note_id == "new")) {
              _context18.next = 8;
              break;
            }
            _context18.next = 5;
            return new KivaProxy({
              endpoint: "/act/task/" + record_id + "/note"
            }).create({
              body: note.message
            }).then(function (data) {
              if (data.success == true) {
                return returnSuccess(data, "CREATE");
              } else {
                return returnError(data.err, "CREATE");
              }
            }).catch(function (err) {
              return returnError(err, "CREATE");
            });
          case 5:
            return _context18.abrupt("return", _context18.sent);
          case 8:
            _context18.next = 10;
            return new KivaProxy({
              endpoint: "/act/task/" + record_id + "/note/" + note.note_id
            }).update({
              body: note.message
            }).then(function (data) {
              if (data.success == true) {
                return returnSuccess(data, "UPDATE");
              } else {
                return returnError(data.err, "UPDATE");
              }
            }).catch(function (err) {
              return returnError(err, "UPDATE");
            });
          case 10:
            return _context18.abrupt("return", _context18.sent);
          case 11:
          case "end":
            return _context18.stop();
        }
      }, _callee18);
    }));
    function save_note(_x19) {
      return _save_note.apply(this, arguments);
    }
    return save_note;
  }(),
  save_dependency: function () {
    var _save_dependency = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(items) {
      var all_items, records, patch, post, post_return, patch_return;
      return _regeneratorRuntime().wrap(function _callee19$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            if (!items) {
              _context19.next = 21;
              break;
            }
            all_items = Object.keys(items);
            records = [];
            patch = [];
            post = [];
            all_items.forEach(function (p, i) {
              // console.log(subtasks[p])
              if (items[p] && p != "me") {
                var params = _objectSpread({}, items[p]);
                if (params && params.dependency_type && params.dependency_type.value) {
                  params.dependency_type = params.dependency_type.value;
                }
                if (params && params.dependent_task && params.dependent_task.value) {
                  params.dependent_task = params.dependent_task.value;
                }
                if (params && params.dependency_type && params.dependency_type.value) {
                  params.dependency_type = params.dependency_type.value;
                }
                if (params && params.task && params.task.value) {
                  params.task = params.task.value;
                }
                if (params && params.record_owner && params.record_owner.value) {
                  params.record_owner = params.record_owner.value;
                } else if (params && params.record_owner && params.record_owner.userId) {
                  params.record_owner = params.record_owner.userId;
                }
                params.sort_order = i;
                if (params.dependency_type != 1) {
                  params.dependent_task = '';
                }
                if (params.dependency_type == 3) {
                  var me = items.me;
                  params.record_owner = me.userId ? me.userId : 0;
                }
                if (params.record_id && params.record_id != null && params.record_id != "0" && params.record_id != "new") {
                  patch.push(_objectSpread({}, params));
                } else {
                  post.push(_objectSpread({}, params));
                }
                records.push(_objectSpread({}, params));
              }
            });

            // console.log("post",post)
            // console.log("patch",patch)
            post_return = {};
            patch_return = {};
            if (!patch[0]) {
              _context19.next = 12;
              break;
            }
            _context19.next = 11;
            return new KivaProxy({
              endpoint: 'act/task_dependency'
            }).update(patch).then(function (data) {
              if (data.success == true) {
                if (patch[0].duration > 0) {
                  var newCreate = {};
                  newCreate.start_date = patch[0].start_date;
                  newCreate.task = patch[0].task;
                  newCreate.description = patch[0].solution;
                  newCreate.time = patch[0].duration * 60;
                  newCreate.draft = null;
                  newCreate.seconds = newCreate.time % 60;
                  newCreate.minutes = Math.floor(newCreate.time / 60) % 60;
                  newCreate.hours = Math.floor(newCreate.time / 60 / 60);
                  new KivaProxy({
                    endpoint: 'act/time_entry'
                  }).create(newCreate).then(function (dataTE) {
                    if (dataTE.success == true) {}
                  }).catch(function (err) {
                    console.log(err);
                  });
                }
                return returnSuccess(data, "UPDATE");
              } else {
                return returnError(data.err, "UPDATE");
              }
            }).catch(function (err) {
              return returnError(err, "UPDATE");
            });
          case 11:
            patch_return = _context19.sent;
          case 12:
            if (!post[0]) {
              _context19.next = 16;
              break;
            }
            _context19.next = 15;
            return new KivaProxy({
              endpoint: 'act/task_dependency'
            }).create(post).then(function (data) {
              if (data.success == true) {
                return returnSuccess(data, "CREATE");
              } else {
                return returnError(data.err, "CREATE");
              }
            }).catch(function (err) {
              return returnError(err, "CREATE");
            });
          case 15:
            post_return = _context19.sent;
          case 16:
            if (!(post_return.status != "fail" && patch_return.status != "fail")) {
              _context19.next = 21;
              break;
            }
            if (!post_return.status) {
              _context19.next = 19;
              break;
            }
            return _context19.abrupt("return", post_return);
          case 19:
            if (!patch_return.status) {
              _context19.next = 21;
              break;
            }
            return _context19.abrupt("return", patch_return);
          case 21:
            return _context19.abrupt("return", {
              status: "Fail",
              records: [],
              text: "Veri Bulunamadı",
              err: "Veri yok!!"
            });
          case 22:
          case "end":
            return _context19.stop();
        }
      }, _callee19);
    }));
    function save_dependency(_x20) {
      return _save_dependency.apply(this, arguments);
    }
    return save_dependency;
  }(),
  list_task_dependency: function () {
    var _list_task_dependency = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(params) {
      var jsearch, res;
      return _regeneratorRuntime().wrap(function _callee21$(_context21) {
        while (1) switch (_context21.prev = _context21.next) {
          case 0:
            jsearch = {
              status: ["=", 1],
              task: ["=", params.record_id]
            };
            _context21.next = 3;
            return new KivaProxy({
              endpoint: 'act/task_dependency'
            }).setFilters(jsearch).setFields(["sort_order", "urgent", "done", "task", "solution", "dependent_task", "description", "dependency_type", "duration", "record_owner", "created_on", "created_by"]).setSort("sort_order").setDir('ASC').all().then( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(data) {
                return _regeneratorRuntime().wrap(function _callee20$(_context20) {
                  while (1) switch (_context20.prev = _context20.next) {
                    case 0:
                      _context20.next = 2;
                      return data.records;
                    case 2:
                      _context20.t0 = _context20.sent;
                      return _context20.abrupt("return", {
                        status: "Success",
                        records: _context20.t0
                      });
                    case 4:
                    case "end":
                      return _context20.stop();
                  }
                }, _callee20);
              }));
              return function (_x22) {
                return _ref3.apply(this, arguments);
              };
            }()).catch(function (err) {
              return {
                status: "Fail",
                records: []
              };
            });
          case 3:
            res = _context21.sent;
            return _context21.abrupt("return", res);
          case 5:
          case "end":
            return _context21.stop();
        }
      }, _callee21);
    }));
    function list_task_dependency(_x21) {
      return _list_task_dependency.apply(this, arguments);
    }
    return list_task_dependency;
  }(),
  delete_dependency: function () {
    var _delete_dependency = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(params) {
      var record_id, response;
      return _regeneratorRuntime().wrap(function _callee22$(_context22) {
        while (1) switch (_context22.prev = _context22.next) {
          case 0:
            record_id = params.record_id;
            if (!(record_id && record_id != null)) {
              _context22.next = 6;
              break;
            }
            response = new KivaProxy({
              endpoint: "act/task_dependency"
            }).destroy(record_id).then(function (data) {
              if (data.success == true) {
                return returnSuccess(data, "DELETE");
              } else {
                return returnError(data.err, "DELETE");
              }
            }).catch(function (err) {
              return returnError(err, "DELETE");
            });
            return _context22.abrupt("return", response);
          case 6:
            return _context22.abrupt("return", {
              status: "Fail",
              records: [],
              text: "Can not get required parameters.",
              err: "err"
            });
          case 7:
          case "end":
            return _context22.stop();
        }
      }, _callee22);
    }));
    function delete_dependency(_x23) {
      return _delete_dependency.apply(this, arguments);
    }
    return delete_dependency;
  }(),
  get_time_entry: function () {
    var _get_time_entry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(params) {
      var jsearch, limit;
      return _regeneratorRuntime().wrap(function _callee24$(_context24) {
        while (1) switch (_context24.prev = _context24.next) {
          case 0:
            jsearch = {};
            if (params.record_id) {
              jsearch.task = ["=", params.record_id];
            }
            if (params.task) {
              jsearch.task = ["=", params.task];
            }
            if (params.thread) {
              jsearch.thread = ["=", params.thread];
            }
            if (params.event) {
              jsearch.event = ["=", params.event];
            }
            if (params.project) {
              jsearch.project = ["=", params.project];
            }
            if (params.record_owner) {
              jsearch.record_owner = ["=", params.record_owner];
            }
            limit = params.limit ? params.limit : 500;
            _context24.next = 10;
            return new KivaProxy({
              endpoint: 'act/time_entry'
            }).setFilters(jsearch).setFields(["duration", "event", "paused", "project", "thread", "account_name", "hours", "minutes", "duration_formatted", "task", "description", "start_date", "record_owner", "created_on", "created_by"]).setSort("start_date").setDir('DESC').setLimit(limit).all().then( /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(data) {
                var records;
                return _regeneratorRuntime().wrap(function _callee23$(_context23) {
                  while (1) switch (_context23.prev = _context23.next) {
                    case 0:
                      records = data.records.map(function (k) {
                        var x = k;
                        x.project_LABEL = k.project && k.project.label ? k.project.label : null;
                        x.project = k.project && k.project.value ? k.project.value : null;
                        x.thread_LABEL = k.thread && k.thread.label ? k.thread.label : null;
                        x.thread = k.thread && k.thread.value ? k.thread.value : null;
                        x.account_name_LABEL = k.account_name && k.account_name.label ? k.account_name.label : null;
                        x.account_name = k.account_name && k.account_name.value ? k.account_name.value : null;
                        x.task_LABEL = k.task && k.task.label ? k.task.label : null;
                        x.task = k.task && k.task.value ? k.task.value : null;
                        return x;
                      });
                      return _context23.abrupt("return", {
                        status: "Success",
                        records: data.records
                      });
                    case 2:
                    case "end":
                      return _context23.stop();
                  }
                }, _callee23);
              }));
              return function (_x25) {
                return _ref4.apply(this, arguments);
              };
            }()).catch(function (err) {
              return {
                status: "Fail",
                records: []
              };
            });
          case 10:
            return _context24.abrupt("return", _context24.sent);
          case 12:
          case "end":
            return _context24.stop();
        }
      }, _callee24);
    }));
    function get_time_entry(_x24) {
      return _get_time_entry.apply(this, arguments);
    }
    return get_time_entry;
  }(),
  save_time_entry: function save_time_entry(all_params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
      var params, task, records;
      return _regeneratorRuntime().wrap(function _callee25$(_context25) {
        while (1) switch (_context25.prev = _context25.next) {
          case 0:
            params = all_params.data;
            task = all_params.task;
            params.hours = params.hours ? params.hours : 0;
            params.status = params.status ? params.status : '1';
            params.minutes = params.minutes ? params.minutes : 0;
            params.record_owner = params.record_owner ? params.record_owner.value ? params.record_owner.value : params.record_owner : '';
            params.project = typeof params.project == 'number' ? params.project : params.project ? params.project.value ? params.project.value : params.project.record_id ? params.project.record_id : params.project ? params.project : '' : '';
            params.task = typeof params.task == 'number' ? params.task : params.task && params.task.value ? params.task.value : params.task ? params.task : '';
            params.section = typeof params.section == 'number' ? params.section : params.task && params.task.section ? params.task.section : params.section ? params.section : '';
            params.thread = typeof params.thread == 'number' ? params.thread : params.thread && params.thread.value ? params.thread.value : '';
            params.event = typeof params.event == 'number' ? params.event : params.event && params.event.value ? params.event.value : '';
            params.dependency_id = typeof params.dependency_id == 'number' ? params.dependency_id : '';
            params.dependency_task = typeof params.dependency_task == 'number' ? params.dependency_task : '';
            console.log("task_head_cols", params);
            records = [_objectSpread(_objectSpread({}, params), {}, {
              duration: params.minutes * 1 + params.hours * 60
            })]; //Silme işlemi 
            if (!(params.record_id && params.record_id != null && params.record_id != "0" && params.record_id != "new")) {
              _context25.next = 27;
              break;
            }
            if (!(params.status == '2')) {
              _context25.next = 22;
              break;
            }
            _context25.next = 19;
            return new KivaProxy({
              endpoint: 'act/time_entry'
            }).destroy(params.record_id).then(function (data) {
              if (data.success == true) {
                return returnSuccess(data, "DELETE");
              } else {
                return returnError(data.err, "DELETE");
              }
            }).catch(function (err) {
              return returnError(err, "DELETE");
            });
          case 19:
            return _context25.abrupt("return", _context25.sent);
          case 22:
            _context25.next = 24;
            return new KivaProxy({
              endpoint: 'act/time_entry'
            }).update(records).then(function (data) {
              if (data.success == true) {
                // eğer dependency aynı zamanda done yapılmak istendiyse 
                if (params.dependency_id && params.dependency_task == params.task) {
                  new KivaProxy({
                    endpoint: 'act/task_dependency'
                  }).update([{
                    done: 1,
                    record_id: params.dependency_id
                  }]);
                }
                return returnSuccess(data, "UPDATE");
              } else {
                return returnError(data.err, "UPDATE");
              }
            }).catch(function (err) {
              return returnError(err, "UPDATE");
            });
          case 24:
            return _context25.abrupt("return", _context25.sent);
          case 25:
            _context25.next = 30;
            break;
          case 27:
            _context25.next = 29;
            return new KivaProxy({
              endpoint: 'act/time_entry'
            }).create(records).then(function (data) {
              if (data.success == true) {
                if (params.dependency_id && params.dependency_task == params.task) {
                  new KivaProxy({
                    endpoint: 'act/task_dependency'
                  }).update([{
                    done: 1,
                    record_id: params.dependency_id
                  }]);
                }
                return returnSuccess(data, "CREATE");
              } else {
                return returnError(data.err, "CREATE");
              }
            }).catch(function (err) {
              return returnError(err, "CREATE");
            });
          case 29:
            return _context25.abrupt("return", _context25.sent);
          case 30:
          case "end":
            return _context25.stop();
        }
      }, _callee25);
    }))();
  },
  /* 
          Files & Uploads 
  */

  get_attachments: function () {
    var _get_attachments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(params) {
      var search, record_id, app, model;
      return _regeneratorRuntime().wrap(function _callee26$(_context26) {
        while (1) switch (_context26.prev = _context26.next) {
          case 0:
            search = {};
            record_id = "";
            app = "";
            model = "";
            if (params.account_name) {
              search.account_name = ["=", params.account_name];
            }
            if (params.record_id) {
              record_id = params.record_id;
            }
            if (params.app) {
              app = params.app;
            }
            if (params.model) {
              model = params.model;
            }
            if (!(record_id && model && app)) {
              _context26.next = 12;
              break;
            }
            _context26.next = 11;
            return new KivaProxy({
              endpoint: app + "/" + model + "/" + record_id + "/attachment"
            }).setLimit(1000).all().then(function (data) {
              return {
                status: "Success",
                records: data.records
              };
            }).catch(function (err) {
              return {
                status: "Fail",
                records: []
              };
            });
          case 11:
            return _context26.abrupt("return", _context26.sent);
          case 12:
          case "end":
            return _context26.stop();
        }
      }, _callee26);
    }));
    function get_attachments(_x26) {
      return _get_attachments.apply(this, arguments);
    }
    return get_attachments;
  }(),
  get_attachment: function () {
    var _get_attachment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(params) {
      var search, record_id, attachment_id;
      return _regeneratorRuntime().wrap(function _callee27$(_context27) {
        while (1) switch (_context27.prev = _context27.next) {
          case 0:
            search = {};
            record_id = "";
            attachment_id = "";
            if (params.account_name) {
              search.account_name = ["=", params.account_name];
            }
            if (params.record_id) {
              record_id = params.record_id;
            }
            if (params.attachment_id) {
              attachment_id = params.attachment_id;
            }
            _context27.next = 8;
            return new KivaProxy({
              endpoint: "act/task/" + record_id + "/attachment/" + attachment_id
            }).setLimit(1).all().then(function (data) {
              return data;
            }).catch(function (err) {
              console.log(err);
              return [];
            });
          case 8:
            return _context27.abrupt("return", _context27.sent);
          case 9:
          case "end":
            return _context27.stop();
        }
      }, _callee27);
    }));
    function get_attachment(_x27) {
      return _get_attachment.apply(this, arguments);
    }
    return get_attachment;
  }(),
  delete_attachment: function () {
    var _delete_attachment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(params) {
      var search, record_id, attachment_id, model, app;
      return _regeneratorRuntime().wrap(function _callee28$(_context28) {
        while (1) switch (_context28.prev = _context28.next) {
          case 0:
            search = {};
            record_id = "";
            attachment_id = "";
            if (params.record_id) {
              record_id = params.record_id;
            }
            if (params.attachment_id) {
              attachment_id = params.attachment_id;
            }
            model = "task";
            app = "act";
            if (params.model) {
              model = params.model;
            }
            if (params.app) {
              app = params.app;
            }
            _context28.next = 11;
            return new KivaProxy({
              endpoint: app + "/" + model + "/" + record_id + "/attachment"
            }).destroy(attachment_id).then(function (data) {
              if (data.success == true) {
                return returnSuccess(data, "DELETE");
              } else {
                return returnError(data.err, "DELETE");
              }
            }).catch(function (err) {
              return returnError(err, "DELETE");
            });
          case 11:
            return _context28.abrupt("return", _context28.sent);
          case 12:
          case "end":
            return _context28.stop();
        }
      }, _callee28);
    }));
    function delete_attachment(_x28) {
      return _delete_attachment.apply(this, arguments);
    }
    return delete_attachment;
  }(),
  upload_attachments: function () {
    var _upload_attachments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(attachment) {
      var record_id, app, model, files;
      return _regeneratorRuntime().wrap(function _callee29$(_context29) {
        while (1) switch (_context29.prev = _context29.next) {
          case 0:
            record_id = attachment.record_id;
            app = attachment.app;
            model = attachment.model;
            files = attachment.files;
            _context29.next = 6;
            return new KivaProxy({
              endpoint: app + "/" + model + "/" + record_id + "/attachment"
            }).submit('post', app + "/" + model + "/" + record_id + "/attachment", files).then(function (data) {
              if (data.success == true) {
                return returnSuccess(data, "UPLOAD");
              } else {
                return returnError(data.err, "UPLOAD");
              }
            }).catch(function (err) {
              console.log(err);
              return returnError(err, "UPLOAD");
            });
          case 6:
            return _context29.abrupt("return", _context29.sent);
          case 7:
          case "end":
            return _context29.stop();
        }
      }, _callee29);
    }));
    function upload_attachments(_x29) {
      return _upload_attachments.apply(this, arguments);
    }
    return upload_attachments;
  }()
};
export default Main;
var returnError = function returnError(err, target) {
  var text = "Saving";
  if (target == "DELETE") {
    text = "Deleting";
  }
  if (target == "CREATE") {
    text = "Creating";
  }
  if (target == "UPDATE") {
    text = "Updating";
  }
  if (target == "UPLOAD") {
    text = "Uploading";
  }
  return {
    status: "Fail",
    records: [],
    text: "".concat(text, " failed."),
    err: err ? err.description : ''
  };
};
var returnSuccess = function returnSuccess(data, target) {
  var text = "saved";
  if (target == "DELETE") {
    text = "deleted";
  }
  if (target == "CREATE") {
    text = "created";
  }
  if (target == "UPDATE") {
    text = "updated";
  }
  if (target == "UPLOAD") {
    text = "uploaded";
  }
  return {
    status: "Success",
    records: data && data.records ? data.records : data,
    text: "Successfully ".concat(text, "."),
    err: ''
  };
};
var get_responsibles_in_arr = function get_responsibles_in_arr(responsibles) {
  if (typeof responsibles == "string" || typeof responsibles == "number") {
    responsibles = [responsibles];
  }
  var obj = {};
  obj.record_owner = responsibles && responsibles[0] ? responsibles[0] : '';
  var followers = responsibles.filter(function (k, i) {
    return i != 0;
  });
  obj.followers = followers.map(function (k) {
    return 'U' + k;
  });
  obj.followers = obj.followers && obj.followers[0] ? obj.followers.join(",") : '';
  return obj;
};